import axiosInstance from "client/services/Backend/axiosInstance";
import { getUrlExtension } from "./getUrlExtension";

export const heicExtensions = ["heic", "heif", ".heic", ".heif"];

export const downloadImage = async (
    url: string,
    size: number,
    onDownloadProgress?: (progressEvent: number, downloadedSize: number) => void,
    headers?: any,
    ext?: string,
): Promise<{ src: string; error?: boolean }> => {
    return new Promise<{
        src: string;
        error?: boolean;
    }>((resolve, _reject) => {
        axiosInstance
            .get(url, {
                onDownloadProgress: (progressEvent: ProgressEvent) => {
                    const progress = Math.floor((progressEvent.loaded / (size || progressEvent.total)) * 100);
                    onDownloadProgress && onDownloadProgress(progress, progressEvent.loaded);
                },
                headers: {
                    ...(headers ?? {}),
                },
                responseType: "blob",
            })
            .then(async (response) => {
                if (heicExtensions.includes(getUrlExtension(url)) || (ext && heicExtensions.includes(ext))) {
                    const heic2any = (await import("heic2any")).default;
                    const conversionRes = await heic2any({ blob: response.data });
                    resolve({
                        src: URL.createObjectURL(Array.isArray(conversionRes) ? conversionRes[0] : conversionRes),
                    });
                    return;
                }
                const reader = new FileReader();
                reader.readAsDataURL(response.data);
                reader.onload = async function (e) {
                    const imageDataUrl = reader.result;
                    if (!imageDataUrl) return;

                    if (imageDataUrl instanceof ArrayBuffer) {
                        resolve({ src: imageDataUrl.toString() });
                    } else if (typeof imageDataUrl === "string") {
                        resolve({ src: imageDataUrl });
                    }
                };
                reader.onerror = function (error) {
                    resolve({ src: "", error: true });
                };
            })
            .catch((e) => {
                resolve({ src: "", error: true });
            });
    });
};
